// extracted by mini-css-extract-plugin
export var divider = "_sv-0";
export var systemMessage = "_sv-1";